module.exports = "<div class=itemDetailsInventory ng-cloak layout=row> <div ng-if=\"c.inventory && c.inventory.length === 0\" flex layout=row> <span flex=30></span> <div layout=row flex> <div class=\"circle md-whiteframe-z2\" layout=row layout-align=\"center center\"> <h3 class=white-text>Ingen beholdningsinformasjon</h3> </div> </div> </div> <md-card ng-if=\"c.tableDefinition.promise || c.inventory.length > 0\" flex> <rkc-table table-definition=c.tableDefinition table-content=c.inventory></rkc-table> </md-card> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/main/views/items/itemDetails/itemDetailsInventory/itemDetailsInventory.html
 ** module id = 504
 ** module chunks = 0
 **/